import styled from 'vue-styled-components'
import { rgba } from '../../../library/lib'

const theme = {
  font: String,
  primary: String,
  borderRadius: Number,
  shadowOffsetX: Number,
  shadowOffsetY: Number,
  shadowRadius: Number,
  shadowOpacity: Number,
  shadow: String
}

const ThemedContactRow = styled('section', theme)`
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            opacity: 0.3;
            transition: opacity 0.3s;
            padding: 7px 10px;
            background: #fff;
            border-radius: ${props => props.borderRadius}px;
            box-shadow: ${props => props.shadowOffsetX}px ${props => props.shadowOffsetY}px ${props => props.shadowRadius}px ${props => rgba(props.shadow, props.shadowOpacity)};

            &.active {
              opacity: 1;
            }

            .ico-wrap {
              flex: 0 0 25px;
              margin-right: 8px;
              max-width: 25px;
              text-align: left;

              .icon {
                color: ${props => props.primary};
              }
            }
              .link {
                font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
                font-size: 13px !important;
                // flex: 1 0 auto;
                display: flex;
                align-items: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                justify-content: space-between;
                width: 100%;

              .forward-icon {
                display: inline-block;
                color: #bbbbbb;
              }
            }
`

export default ThemedContactRow
